if (!global._babelPolyfill) {
	require('@babel/polyfill');
}

import React from 'react';
import { hydrate } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import { loadableReady } from '@loadable/component';

import App from './App';
import configureStore from './redux/store';

let preloadedState = {};
if (typeof window !== 'undefined') {
	preloadedState = window.__PRELOADED_STATE__;
	delete window.__PRELOADED_STATE__;
}
const { store } = configureStore(preloadedState);
loadableReady(() => {
	hydrate(
		<BrowserRouter>
			<Provider store={store}>
				<App />
			</Provider>
		</BrowserRouter>,
		document.querySelector('#root')
	);
});
